import Settings from './settings'

export default {
  ...Settings, // DEV v2
  urlHotFolder: '',
  webSocketUrl: 'wss://devv2.idoccar.com:8009',
  notificationRefresh: 60000,
  showSignDocumentButton: false,
  acceptFileFormats: 'application/pdf, .jpg, .png, .jpeg, .gif, .docx, .doc, .xls, .xlsx, .ppt, .pptx, .msg, .tiff',
  qaSite: true,
  dealerMaxLength: 6,
  dealerNumberRegex: null,
  clientFieldValidation: 'all',
  dashboardWithProcedure: true,
  autoLoadDashboard: true,
  validateLicensePlate: true,
  maxTagCount: 2,
  maxTagTextLength: 10,
  matomoSiteId: '0'
}
